import BG from '../Auth2/bg.jpg';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Snackbar,
  Alert, Divider, Stack
} from '@mui/material';
import { styled, keyframes } from '@mui/system';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import BG01 from './img01.jpg';
import Footer from '../../Home/Footer/Footer';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { Notyf } from 'notyf';
    
const notyf = new Notyf({
        position: { x: 'center', y: 'top' },
        duration: 3000,
      });

      const notyf2 = new Notyf({
        position: { x: 'center', y: 'top' },
        duration: 4000,
        dismissible: true,
      });

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
  animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const pastelColors = [
  '#7B9E75', // Darker pastel green
  '#D9B800', // Darker pastel yellow
  '#F07A2B', // Darker pastel orange
  '#D74359', // Darker pastel pink
  '#9E4A84', // Darker pastel purple
  '#F085A0', // Darker pastel lavender
  '#F27A7A', // Darker pastel coral
  '#B6D1A1', // Darker pastel mint
];

const generateOrderId = () => 'ORDER_' + Date.now();

const generateSubscriptionId = () => 'SUB_' + Math.random().toString(36).substr(2, 9).toUpperCase();


const Login = ({ setToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState(0);

  const text1 = " Most efficient POS system for your business.";
  const text2 = "Manage everything seamlessly and effortlessly.";
  const [displayText1, setDisplayText1] = useState('');
  const [displayText2, setDisplayText2] = useState('');
  const [index, setIndex] = useState(0);
  const [reverse, setReverse] = useState(false);
  const [textColor, setTextColor] = useState(pastelColors[0]);

  const typingSpeed = 100; // Speed for typing
  const backspacingSpeed = 50; // Speed for backspacing
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [logoutMessage, setLogoutMessage] = useState('');


  {/**useEffect(() => {
    const message = localStorage.getItem('logoutMessage');
    if (message) {
      setLogoutMessage(message);
      setOpenSnackbar(true);
      localStorage.removeItem('logoutMessage'); 
    }
  }, []);*/}

  useEffect(() => {
    const message = localStorage.getItem('logoutMessage');
    if (message) {
      notyf2.error(message); 
      localStorage.removeItem('logoutMessage');
    }
  }, []);

  useEffect(() => {
    let typingInterval;

    // Function to handle typing effect
    const handleTyping = () => {
      if (!reverse) {
        // Typing text1 and text2
        if (index < text1.length) {
          setDisplayText1(prev => prev + text1[index]);
        } else if (index < text1.length + text2.length) {
          setDisplayText2(prev => prev + text2[index - text1.length]);
        }
      }

      // If we have typed everything, start backspacing
      if (index === text1.length + text2.length && !reverse) {
        setReverse(true);
      }

      // Backspacing logic
      if (reverse) {
        if (displayText2.length > 0) {
          setDisplayText2(displayText2.slice(0, -1));
        } else if (displayText1.length > 0) {
          setDisplayText1(displayText1.slice(0, -1));
        } else {
          // Reset and start typing again with new color
          setReverse(false);
          setIndex(0);
          setDisplayText1('');
          setDisplayText2('');
          setTextColor(pastelColors[Math.floor(Math.random() * pastelColors.length)]); // Change color on reset
        }
      }

      setIndex(prevIndex => prevIndex + 1);
    };

    typingInterval = setInterval(handleTyping, reverse ? backspacingSpeed : typingSpeed);

    // Cleanup interval when done typing or backspacing
    return () => clearInterval(typingInterval);
  }, [index, displayText1, displayText2, reverse]);



  const handleSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  {/**const handleLogin = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await axios.post('https://admin.bizstor.lk/public/api/login', { email, password });
      const token = response.data.token;

      localStorage.setItem('token', token);
      setToken(token);

      handleSnackbar('Login successfully!', 'success');
      setLoading(false);
      navigate('/dashboard');
    } catch (error) {
      handleSnackbar('Login failed!', 'error');
      setLoading(false);
    }
  };*/}

  {/**const handleLogin = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
        const response = await axios.post('https://admin.bizstor.lk/public/api/login', { email, password });
        const token = response.data.token;

        if (token) {
            localStorage.setItem('token', token);
            setToken(token);
            handleSnackbar('Login successfully!', 'success');

            setTimeout(() => {
                navigate('/dashboard'); // Ensure token is stored before redirecting
            }, 200);
        } else {
            handleSnackbar('Invalid response from server!', 'error');
        }
    } catch (error) {
        handleSnackbar('Login failed!', 'error');
    } finally {
        setLoading(false);
    }
};*/}

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post("https://admin.bizstor.lk/public/api/login", { email, password });
      const token = response.data.token;

      if (token) {
        localStorage.setItem("token", token);
        setToken(token);
        //handleSnackbar("Login successfully!", "success");
        notyf.success('Login successfully!');
        setLoading(false);
        navigate("/dashboard");
      }
    } catch (error) {
      //handleSnackbar("Login unsuccessfully!", "error");
      notyf.error('Login failed!');
      setLoading(false);
    }
  };


  const refreshToken = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get('https://admin.bizstor.lk/public/api/refresh-token', {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }
    } catch (error) {
      console.error('Failed to refresh token:', error);
      //handleSnackbar('Session expired. Please log in again.', 'error');
      notyf.error('Session expired. Please log in again!');
      localStorage.removeItem('token');
      navigate('/');
    }
  };

  useEffect(() => {
    const interval = setInterval(refreshToken, 23 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);


  React.useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, []);


  //googlelogin
  {/**const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);

    if (!credentialResponse?.credential) {
      handleSnackbar("Google Credential Missing", "error");
      setLoading(false);
      return;
    }

    try {
      // Send Google Token to backend for verification and registration
      const response = await axios.post("https://admin.bizstor.lk/public/api/google-register", {
        token: credentialResponse.credential,
      });

      const { user, authToken } = response.data;

      // Store authentication token in local storage
      localStorage.setItem("token", authToken);
      setToken(authToken);

      //handleSnackbar("Login successfully!", "success");
      notyf.success('Login successfully!');
      setLoading(false);
      navigate("/dashboard");
    } catch (error) {
      //handleSnackbar("Login failed!", "error");
      notyf.error('Login failed!');
      setLoading(false);
    }
  };*/}

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
  
    if (!credentialResponse?.credential) {
      handleSnackbar("Google Credential Missing", "error");
      setLoading(false);
      return;
    }
  
    try {
      // Send Google Token to backend for verification and registration
      const response = await axios.post("https://admin.bizstor.lk/public/api/google-register", {
        token: credentialResponse.credential,
      });
  
      const { user, authToken, isNewUser } = response.data;
  
      localStorage.setItem("token", authToken);
      setToken(authToken);
  
      if (isNewUser) {
        // Generate subscription info
        const orderId = generateOrderId();
        const subscriptionId = generateSubscriptionId();
  
        const currentPaymentData = {
          user_email: user.email,
          subscription_id: subscriptionId,
          amount: 0,
          user_phone: user.phone || "", 
          first_name: user.name || "",
          last_name: user.name || "",
        };
  
        const selectedPlan = "30 days free";
        const billingCycle = "monthly";
  
        await saveSubscriptionToDatabase(orderId, currentPaymentData, selectedPlan, billingCycle);
      }
  
      notyf.success('Login successfully!');
      setLoading(false);
      navigate("/dashboard");
  
    } catch (error) {
      notyf.error('Login failed!');
      setLoading(false);
    }
  };
  
  const saveSubscriptionToDatabase = async (orderId, currentPaymentData, selectedPlan, billingCycle) => {
    try {
      const response = await fetch('https://admin.bizstor.lk/public/api/save-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: currentPaymentData.user_email,
          plan: selectedPlan,
          billing_cycle: billingCycle,
          subscription_id: currentPaymentData.subscription_id,
          amount: currentPaymentData.amount,
          order_id: orderId,
          payment_status: 'completed',
          user_phone: currentPaymentData.user_phone,
          first_name: currentPaymentData.first_name,
          last_name: currentPaymentData.last_name
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to save subscription data');
      }

      //console.log('Subscription data saved successfully:', data);
    } catch (error) {
      console.error('Failed to save subscription:', error);
      //alert('There was an issue saving your subscription. Please contact support with your order ID: ' + orderId);
    }
  };



  return (
    <Container maxWidth="lg">
      <Helmet>
        <meta
          name="description"
          content="Bizstor.lk offers the most efficient POS system in Sri Lanka. Manage sales, inventory, and reports seamlessly with our user-friendly software."
        />
        <meta
          name="keywords"
          content="POS system Sri Lanka, Bizstor, inventory management, sales tracking, POS software Sri Lanka, online POS system"
        />
        <meta name="author" content="Bizstor.lk" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://bizstor.lk/" />
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          width: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
        }}
      >

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // background: 'url(${BG}) center / cover no-repeat',
            //bgcolor: 'rgba(189, 189, 189, 0.8)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 4,
              //boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              bgcolor: '#FAFAFA',
              //zIndex: 1,
            }}
          >
            <Box
              sx={{
                display: { xs: 'flex', sm: 'none' },
              }}
            >
              <h1>BIZSTOR</h1>
            </Box>

            <AnimatedTypography key={key} component="h1" variant="h5" fontWeight={600}>
              Login
            </AnimatedTypography>
            <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
              <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                <Link to="/forgot-password" style={{ textDecoration: 'none' }}>Forgot Password ?</Link>
              </Typography>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  borderRadius: 20,
                  background: 'rgb(29, 29, 29)',
                  '&:hover': {
                    backgroundColor: 'black',
                  },
                }}
              >
                Login
              </Button>

              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ mb: 1, width: "100%" }}>
                <Stack direction="row" alignItems="center" spacing={1} width="100%" mb={1}>
                  <Divider sx={{ flex: 1 }} />
                  <Typography variant="body" sx={{ mx: 1, color: 'text.secondary' }}>
                    OR
                  </Typography>
                  <Divider sx={{ flex: 1 }} />
                </Stack>

                <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => console.log("Login Failed")} />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Typography variant="body2" mt={2}>
                  Don't have an account? <Link to="/register" style={{ textDecoration: 'none' }}>Create an Account</Link>
                </Typography>
                <Typography variant="body2" mt={1}>
                  Back to <Link to="/" style={{ textDecoration: 'none' }}>Home</Link>
                </Typography>
              </Box>

              {loading && (
                <Box sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                  zIndex: 9999
                }}>
                  <l-trio size="50" speed="1.3" color="red"></l-trio>
                </Box>
              )}
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbarSeverity}
                  sx={{ width: '100%' }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
              <Snackbar
                open={openSnackbar}
                autoHideDuration={100000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{ mt: 1 }}
              >
                <Alert onClose={() => setOpenSnackbar(false)} severity="warning">
                  {logoutMessage}
                </Alert>
              </Snackbar>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
